/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedRingSizeDetail_detailValues = ReadonlyArray<{
    readonly detailKey: string | null;
    readonly browseUrl?: string | null | undefined;
    readonly ringSizes?: ReadonlyArray<{
        readonly unit: string | null;
        readonly value: string | null;
    } | null> | null | undefined;
    readonly " $refType": "PdpSharedRingSizeDetail_detailValues";
}>;
export type PdpSharedRingSizeDetail_detailValues$data = PdpSharedRingSizeDetail_detailValues;
export type PdpSharedRingSizeDetail_detailValues$key = ReadonlyArray<{
    readonly " $data"?: PdpSharedRingSizeDetail_detailValues$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRingSizeDetail_detailValues">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedRingSizeDetail_detailValues",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detailKey",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "browseUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RingSizeDetail",
          "kind": "LinkedField",
          "name": "ringSizes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "PdpDetailRingSize",
      "abstractKey": null
    }
  ],
  "type": "PdpDetailValueInterface",
  "abstractKey": "__isPdpDetailValueInterface"
};
(node as any).hash = '3623ab36a1a6cb09c51800a820952000';
export default node;
